export const ADD_OPERATOR_REQUEST = "ADD_OPERATOR_REQUEST";
export const ADD_OPERATOR_SUCCESS = "ADD_OPERATOR_SUCCESS";
export const ADD_OPERATOR_FAILURE = "ADD_OPERATOR_FAILURE";
